import { DonationAnswers, PendingDocumentMove } from "../../../api/ClientFileApi";

export const DonationsMaxLength = {
  details: 4000,
} as const;

export type DonationAnswerField = keyof DonationAnswers;

export interface DonationsFormValues {
  answers: DonationAnswers;
  donationDocuments: File[];
  documentMoves: PendingDocumentMove[];
}
